import { onMounted, onBeforeUnmount } from 'vue';

export function useClickOutside(elementRef, callback) {
  function handleClick(event) {
    const el = elementRef.value;
    if (el && !el.contains(event.target)) {
      callback();
    }
  }

  onMounted(() => {
    document.addEventListener('click', handleClick);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('click', handleClick);
  });
}
